

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../@theme/components/auth/services/loader.service';
import { LoaderState } from '../@theme/components/auth/models/loader';
@Component({
    selector: 'vta-loader',
    templateUrl: './vta.loader.component.html',
    styleUrls: ['./vta.loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;
  private subscription: Subscription;
  constructor(private loaderService: LoaderService) { }
  ngOnInit() {
    this.subscription = this.loaderService.loaderState
    .subscribe((state: LoaderState) => {
      this.show = state.show;
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
